import * as React from 'react';

import { SearchResponse } from '@algolia/client-search';
import { Product } from '@packages/common';

interface ProductsProps {
  /**
   * @description this holds the current search-response from algolia. 'Search'
   * here does not mean the user did a search or the result is only for the
   * search-page
   */
  productSearchResponse: SearchResponse<Product>;
}

export const ProductsContext = React.createContext({} as ProductsProps);

export const ProductsProvider: React.FC<ProductsProps> = ({ children, productSearchResponse }) => {
  return (
    <ProductsContext.Provider
      value={{
        productSearchResponse,
      }}
    >
      {children}
    </ProductsContext.Provider>
  );
};
